import React, { useState, useLayoutEffect } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const useStyles = makeStyles((theme) => ({
  selectField: {
      width: '350px',
    }
  }));
  
  const SelectSimpleComponent = (props) => {
    const classes = useStyles();
    const [themeType,setThemeType] = useState('dark');
    const [condition, setCondition] = React.useState('1');
    const handleConditionChange = (event) => {
      setCondition(event.target.value);
    };
    useLayoutEffect(() => {
        if(props.activeModeClass === "white-content"){  setThemeType("light")}
        else{setThemeType("dark")}
        
      }, []);
      const THEME = createMuiTheme({
        palette: {
          type: themeType,
          primary: {
            main: '#f8955e',
          },
          secondary: {
            main: '#1d8cf8',
          },
        },
      });
      return (
          <div>
              <MuiThemeProvider theme={THEME}>
               <CssBaseline/>   
               <FormControl >
                <InputLabel shrink id="condition-select">
                  Report Page
                </InputLabel>
                <Select
                  labelId="condition-label"
                  id="condition-select"
                  value={props.selValue}
                  onChange={props.onChange}
                  className={classes.selectField}
                  displayEmpty
                >
                  <MenuItem value={'extension_details'}>User Report</MenuItem>
                  <MenuItem value={'extension_summary'}>User Summary Report</MenuItem>
                  <MenuItem value={'diva_summary'}>Department Summary Report</MenuItem>
                  <MenuItem value={'divb_summary'}>Branch Summary Report</MenuItem>
                  <MenuItem value={'divc_summary'}>Region Summary Report</MenuItem>
                  <MenuItem value={'hunt_by_hour'}>Hunt By Hour Report</MenuItem>
                </Select>
              </FormControl>
               
              </MuiThemeProvider>
          </div>
      )
  }
  export default SelectSimpleComponent;